/**
 * CUSTOM SHOP PAGE and CART edit
 * Customization notes:
 * - quantity-input.liquid needs a class added based on the cart.attributes.customerType. If so add hiro-disabled class to the input and buttons.
 */

(function () {
  /**
   * ADMIN
   */

  $debug = true;
  $disableThisScript = false;

  /**
   * Global VARIABLES
   */

  //Classes, IDs, etc.
  const productInputSelector = "data-quantity-variant-id";
  const singleProductAddToCartSelector = "button.product-form__submit";
  
  //Sniffer elements
  const pageSniffer = document.querySelector(`[${productInputSelector}]`);
  const cartSniffer = document.querySelector("form#cart");
  const productPageSniffer = document.querySelector(".product");

  //Page elements
  const siteHeader = document.querySelector(`header`);
  const menuListElement = siteHeader.querySelector(`nav.header__inline-menu ul`);

  //Waiting times
  const unlockInputAfterCartUpdate = 0;
  const eventDebounceTime = 500;
  const cartObserverDebounceTime = 500;

  //HTML templates
  $templates = {
    menuItem: (href) => `
      <li>
        <a id="HeaderMenu-Bestellijst" class="header__menu-item list-menu__item link link--text focus-inset" href="${href}">
          <span>Bestellijst</span>
        </a>
      </li>
    `
  }

  // Empty Global variables
  let $maxAmount;
  let $currentAmount;
  let $cartItems;
  let $cart;
  let $productInputElements = [];
  let $latestChangedElement;

  // Product IDs
  const $productID = [
    "52387203580244",
    "52387250536788",
    "52387275014484",
    "52387287859540",
    "52387295035732",
    "52387304046932"
  ]

  /**
   * HELPERS FUNCTIONS
   */

  function getInputParentStructure(inputElement) {
    const parent = inputElement.closest(".quantity") || inputElement.closest("quantity-input") || inputElement.parentElement;
    const minusBtn = parent.querySelector(".quantity__button[name='minus']");
    const plusBtn = parent.querySelector(".quantity__button[name='plus']");
    return { parent, minusBtn, plusBtn };
  }

  function removeDefaultDisabledState() {
    $productInputElements.forEach((inputElement) => {
      const { parent, minusBtn, plusBtn } = getInputParentStructure(inputElement);  

      inputElement.classList.remove("hiro-disabled", "hiro-other-product");
      plusBtn.classList.remove("hiro-disabled");
      minusBtn.classList.remove("hiro-disabled");
      if ($debug) console.log('INPUT REMOVED DISABLED STATE', inputElement)
    });
  }

  function lockOtherInputElements(currentInputElement) {
    $productInputElements.forEach((inputElement) => {
      if (inputElement.dataset.quantityVariantId === currentInputElement.dataset.quantityVariantId) return;
      const { parent, minusBtn, plusBtn } = getInputParentStructure(inputElement);  

      inputElement.classList.add("hiro-disabled", "hiro-other-product");
      minusBtn.classList.add("hiro-disabled");
      plusBtn.classList.add("hiro-disabled");
      if ($debug) console.log('ADDED DISABLED STATE', inputElement)
    });
  }

  function createProductInputElementsArray() {
    $productInputElements = [];
    $productID.forEach((id) => {
      inputElement = (productPageSniffer) ? getSingleProductInputElement(id) : getProductInputElement(id);
      if (!inputElement) return;

      getInputParentStructure(inputElement).parent.classList.add("hiro-custom-product-input");
      
      
      $productInputElements.push(inputElement);
    });
  }

  function getProductInputElement(id) {
    const productCollectionInput = document.querySelector(`input[${productInputSelector}="${id}"]`);

    return productCollectionInput;
  }

  function getDomElementCartAmount(inputElement) {
    return Number(inputElement.dataset.cartQuantity);
  }

  function productCollectionInCart () {
    let roomLeftTotal = 0;
    $productInputElements.forEach((inputElement) => {
      roomLeftTotal += getDomElementCartAmount(inputElement);
    });
    if ($debug) console.log('ROOM LEFT TOTAL', roomLeftTotal);
    return roomLeftTotal;
  }

  function updateAllMaxAttributes() {
    $productInputElements.forEach((inputElement) => {
      const productsInCart =  (cartSniffer) ? getCartOnloadItems() : productCollectionInCart();  
      const roomLeftTotal = Math.max(Number($maxAmount) - Number(productsInCart), 0);
      //add correcting meganism when amoun goes below zero (too much in cart)
      if ($debug) console.log('ROOM LEFT TOTAL', roomLeftTotal);

      const inputCartAmount = getDomElementCartAmount(inputElement);

      const inputRoomleft = roomLeftTotal + inputCartAmount;
      
      inputElement.setAttribute("max", inputRoomleft);
      if ($debug) console.log('INPUT MAX', inputElement.getAttribute('max')); 

      //has Max been reached?
        const maxReached = ( inputElement.value >= inputRoomleft)
        inputElement.classList.toggle("hiro-product-max-reached", maxReached);
    });
  }

  function getCartOnloadItems() {
    if (!$cart?.items) return 0;

    const total = $cart.items
      .filter((item) => $productID.includes(String(item.variant_id)))
      .reduce((sum, item) => sum + Number(item.quantity), 0);

      return total;
  }


   /**
   * CART PAGE FUNCTIONS
   */

   function hasMaxReached() {
    if ($currentAmount >= $maxAmount) {
      return true;
    }
    return false;
   }

   

    /**
   * SINGLE PRODUCT PAGE FUNCTIONS
   */

    function getSingleProductInputElement(id) {
      //Find hidden id input to verify the page is product single
      const productSingleInput = document.querySelector(`.product-variant-id[value="${id}"]`);
      if (!productSingleInput) return;
  
      //Looking for the input
      const unlabelledInput = document.querySelector("input.quantity__input");
      return unlabelledInput;
    }

    function setSingleProductInputMax() {
      $productInputElements.forEach((inputElement) => {
        const currentTotalCartAmount = getCartOnloadItems();

        const roomLeftTotal = $maxAmount - currentTotalCartAmount;
        const inputMax = roomLeftTotal;

        inputElement.max = inputMax;

        if(inputMax === 0) {
          inputElement.value  = 0;
        }
      });

    }

    function verifySingleProductMaxAmount(inputEl) {
      if(!inputEl.max) return;
      const value = Number(inputEl.value);
      const max = Number(inputEl.max);

      if (value > max) {
        inputEl.value = max;
        inputEl.setAttribute("value", max);
        if ($debug) console.log("SINGLE CLAMP:", value, "→", max);
      }
    }

    //Single page event listener
  function singleProductAddToCartEvent() {
    if ($debug) console.log("SINGLE: event added");
    const inputEl = document.querySelector("input.quantity__input");
    const submitButton = document.querySelector(singleProductAddToCartSelector);

    inputEl.addEventListener("change", () => verifySingleProductMaxAmount(inputEl));

    // capture: true ensures this fires BEFORE Shopify's own submit handler
    submitButton.addEventListener("click", (e) => {
      verifySingleProductMaxAmount(inputEl);
    }, { capture: true });

    window.subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
      refreshSingleProductCartState();
      if ($debug) console.log('SINGLE PRODUCT QUANTITY UPDATED')
    });
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      refreshSingleProductCartState();
      if ($debug) console.log('SINGLE PRODUCT QUANTITY UPDATED')
    });
  
  }

  function refreshSingleProductCartState() {
    getCart().then(() => {
      $cartItems = Number($cart?.items);

      if (productPageSniffer)  setSingleProductInputMax();
      if (cartSniffer) updateAllMaxAttributes();

      if ($debug) console.log("REFRESH: cart state refreshed", { $maxAmount, $currentAmount });
    });
  }


  /**
   * CORE FUNCTIONS
   */

  //Get the current cart details
  function getCart() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cartResponse) => {
        $cart = {
          items: cartResponse?.items,
          attr: cartResponse?.attributes,
          discount_codes: cartResponse?.discount_codes
        };
        if ($debug) console.log("CART CONTENTS: ", cartResponse);
      });
  }



  /**
   * 
   * Events and Observers
  */

  window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (Number($cart?.attr?.customerType) != 2) return;
    refreshSingleProductCartState()
    //latestCartState = event.cartData;
    console.log('CART UPDATED')

  });

  window.subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
    if (Number($cart?.attr?.customerType) != 2) return;
    refreshSingleProductCartState()
    console.log('Quantitsy UPDATED')
  });
  
  
  function inputObserver() {
    const container = document.querySelector("#main-cart-items") || document.querySelector("#collection-template--27640822661460__featured_collection_TGFGyd")

    if (!container) return;

    function reinitialize () {

      //rebuild local input array
      createProductInputElementsArray();
      
      //add event to refreshed input
      inputChangeEventBinder();

      //update max attributes
      updateAllMaxAttributes();

      //Unlock all inputs.
      setTimeout(() => {
        removeDefaultDisabledState();
      }, 1000);

      if ($debug) console.log('INPUT REPLACED')
    }

    new MutationObserver(() => {
      if (container.querySelector('.quantity__input')) reinitialize();
    }).observe(container, {
      childList: true,
      subtree: true,
    });
  }

  function inputChangeEvent (inputElement) {
    if (inputElement.dataset.hiroChangeBound === "1") return; // already bound

    inputElement.addEventListener("change", () => {
      if ($debug) console.log('INPUT VALUE', inputElement.value);
      if ($debug) console.log('INPUT MAX', inputElement.getAttribute('max'));

      if (Number(inputElement.value) > Number(inputElement.max)){
        setTimeout(() => {
          const { parent, minusBtn, plusBtn } = getInputParentStructure(inputElement);  
          plusBtn.classList.remove("disabled");
          ;}, 800);
        return;
      }

      lockOtherInputElements(inputElement);
    });
  
    inputElement.dataset.hiroChangeBound = "1";
  }

  function inputChangeEventBinder () {
    $productInputElements.forEach((inputElement) => {
      inputChangeEvent(inputElement);
    });
  }

  //function cartInputChangeEventBinder () {
  //  $productInputElements.forEach((inputElement) => {
  //    cartInputChangeEvent(inputElement);
  //  });
  //}

  /**
   * 
   * Other Functions
   */


  function menuTrigger(redirect) {
    if (!menuListElement) return;

    //Replace menu items and home link on site logo
    menuListElement.innerHTML = $templates.menuItem(redirect);

    if ($debug) console.log("SUCCESS: custom menu is active");
  }

  function cartMenuTrigger(redirect) {
    returnToShop = document.querySelector(".title-wrapper-with-link a");
    returnToShopButton = document.querySelector(".cart__warnings a.button");
    returnToShop.href = redirect;
    returnToShopButton.href = redirect;
  }

  function cartEnterKeyGuard() {
    if (!cartSniffer) return;
    cartSniffer.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      e.target.blur();
    });
  }


  function singleProductEnterKeyGuard() {
    if (!productPageSniffer) return;
    document.querySelector("input.quantity__input").addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      e.target.blur();
    });
  }
  
  function isDiscountCodeActive(expectedCode, discountCodes) {
    if (!expectedCode) return false;
  
    const normalizedExpected = String(expectedCode).trim().toLowerCase();
    if (!normalizedExpected) return false;
  
    if (!Array.isArray(discountCodes) || discountCodes.length === 0) return false;
  
    return discountCodes.some((d) => {
      if (!d) return false;
      const code = String(d.code || "").trim().toLowerCase();
      return code === normalizedExpected
    });
    
  }

  /**
   * Remote discount validation via Cloudflare Worker.
   * Returns true if the code passes all checks.
   *
   * IMPORTANT: on any error (network failure, worker down, unexpected response)
   * this defaults to TRUE so the customer experience still loads.
   * Change `return true` to `return false` below if you'd rather block on failure.
   */
  async function checkDiscountValidity(code) {
    try {
      const res = await fetch(
        `https://shopify-discount-check.newbuttons.workers.dev?code=${encodeURIComponent(code)}`
      );

      if (!res.ok) throw new Error(`Worker responded with ${res.status}`);

      const data = await res.json();

      if ($debug) console.log("DISCOUNT WORKER RESPONSE:", data);

      // Check if the code is still valid (not expired, not deleted, etc.)
      const isUsed = data.used

      if ($debug) console.log("DISCOUNT CHECK:", { isUsed });

      // Both must pass. Comment out either line to skip that check.
      if (isUsed) return false;

      return true;
    } catch (error) {
      if ($debug) console.error("DISCOUNT WORKER ERROR:", error);
      // DEFAULT TRUE: if the worker is unreachable, allow the experience.
      // Change to `return false` to block the experience on worker failure.
      return true;
    }
  }



  /** 
   * INIT
   */

  function init() {
    getCart().then(async () => {
      //Scoped variables
      const checkAttribute = $cart?.attr?.customerType;
      const isMonitoredCustomer = Number($cart?.attr?.customerType) === 2;
      const redirect = $cart?.attr?.redirect;
      const discountCode = $cart?.attr?.discountCode;
      const discountCodeActive = $cart?.discount_codes
     
     
      //Global variables
      $maxAmount = Number($cart?.attr?.maxAmount);
      $cartItems = Number($cart?.items);
      $currentAmount = (() => { return getCartOnloadItems() })();

      if (!checkAttribute) {
        //Check if visitor got here through link, by checking custom attribute presence - could be any attribute
        //if ($debug) console.log("BLOCKED: not enter through link");
        return;
      }

      //Step 1: Quick local check — is the expected discount code present in the cart?
      const discountCodeInCart = isDiscountCodeActive(discountCode, discountCodeActive);
      
      if (!discountCodeInCart) {
        createProductInputElementsArray();
        removeDefaultDisabledState();
      
        const bodyClasses = document.body.classList;
        bodyClasses.remove("hiro-customer-" + checkAttribute, 'hiro-custom','hiro-orderpage','hiro-cart','hiro-single');
      
        if ($debug) console.log('BLOCKED: discount not in cart, cleaned up and exiting');
        return;
      }

      //Step 2: Remote check — is the discount code still valid on the server?
      const discountStillValid = await checkDiscountValidity(discountCode);

      if (!discountStillValid) {
        createProductInputElementsArray();
        removeDefaultDisabledState();
      
        const bodyClasses = document.body.classList;
        bodyClasses.remove("hiro-customer-" + checkAttribute, 'hiro-custom','hiro-orderpage','hiro-cart','hiro-single');
      
        if ($debug) console.log('BLOCKED: discount no longer valid (worker check), cleaned up and exiting');
        return;
      }
      
      // Discount is active and valid → run full experience
      menuTrigger(redirect);

      //Set begin state
      createProductInputElementsArray();
      removeDefaultDisabledState();


      if (!isMonitoredCustomer) {
        //Check if visitor is type "type 2" - in need to limit the order amount
        if ($debug) console.log("BLOCKED: no order limites for customer");
        return;
      }


      if (productPageSniffer) {
        //SINGLE PRODUCT PAGE
        document.body.classList.add("hiro-single");
        setSingleProductInputMax();
        singleProductEnterKeyGuard();
        singleProductAddToCartEvent();
      } else if (cartSniffer) {
        // GENERAL 
        document.body.classList.add("hiro-cart");
        window.onload = () => {
          if($debug) console.log('WINDOW LOADED');
          updateAllMaxAttributes();
        }

        inputChangeEventBinder();
        inputObserver();
        updateAllMaxAttributes()

        //CART SPECIFC FUNCTIONS
        cartMenuTrigger(redirect)
        cartEnterKeyGuard();
  
      } else  {
        //COLLECTION PAGE OR CART PAGE
        document.body.classList.add("hiro-orderpage");

        window.onload = () => {
            console.log('WINDOW LOADED');
            updateAllMaxAttributes();
          }

        inputChangeEventBinder();
        inputObserver();
        updateAllMaxAttributes()

      }

    });
  }


  init();

  //Restore fresh cart state when page is loaded from bfcache (back/forward navigation)
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      if ($debug) console.log("PAGESHOW: page restored from bfcache");
    }
  });

  //Admin Actions
  if($debug) {
    window.getCart = getCart;
    window.currentCartAmount = () => { return $currentAmount };
    window.cartInputElements = () => { return $productInputElements };
  }

  if ($disableThisScript) {
    if ($debug) console.log("BLOCKED: script is disabled");
    removeDefaultDisabledState()
    return;
  }
})();
